import React from "react";

export const TokenContext = React.createContext();
export const UserContext = React.createContext();